// extracted by mini-css-extract-plugin
export default {"lang":"Lang_lang__EputY","text":"Lang_text__28LA4"};